/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse,
  GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams,
  GetTournamentsTournamentidReplayMetricsPlayersUserid404,
} from "../types/GetTournamentsTournamentidReplayMetricsPlayersUserid.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsTournamentidReplayMetricsPlayersUseridQueryKey = (
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["tournamentId"]
    | undefined,
  userId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["userId"]
    | undefined,
) =>
  [
    {
      url: "/tournaments/:tournamentId/replay-metrics/players/:userId",
      params: { tournamentId: tournamentId, userId: userId },
    },
  ] as const;

export type GetTournamentsTournamentidReplayMetricsPlayersUseridQueryKey =
  ReturnType<
    typeof getTournamentsTournamentidReplayMetricsPlayersUseridQueryKey
  >;

/**
 * @summary Метрики одного игрока за турнир — агрегат по всем его играм с перцентилями по роли.
 * Нет данных по игроку — это `200` с телом `null`, а НЕ `404`. Раньше был 404, и
 * он был неправ дважды: ресурс существует, пока существует турнир, а браузер красит
 * 404 красным всегда — самый обычный сценарий выглядел в консоли как сбой и создавал
 * фон, в котором теряется настоящая ошибка (KAN-1055).
 * `null`, а не пустой объект с нулями: «игрока нет в данных турнира» и «сыграл, но
 * ничего не делал» — разные факты, нули выглядели бы как второе.
 * 404 остаётся там, где ресурса действительно нет: несуществующий турнир.
 * {@link /tournaments/:tournamentId/replay-metrics/players/:userId}
 */
export async function getTournamentsTournamentidReplayMetricsPlayersUserid(
  tournamentId: GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["tournamentId"],
  userId: GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["userId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsPlayersUserid404>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${tournamentId}/replay-metrics/players/${userId}`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsTournamentidReplayMetricsPlayersUseridQueryOptions(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["tournamentId"]
    | undefined,
  userId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["userId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsTournamentidReplayMetricsPlayersUseridQueryKey(
    tournamentId,
    userId,
  );
  return queryOptions<
    ResponseConfig<GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse>,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsPlayersUserid404>,
    ResponseConfig<GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(tournamentId && userId),
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsTournamentidReplayMetricsPlayersUserid(
        tournamentId!,
        userId!,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @summary Метрики одного игрока за турнир — агрегат по всем его играм с перцентилями по роли.
 * Нет данных по игроку — это `200` с телом `null`, а НЕ `404`. Раньше был 404, и
 * он был неправ дважды: ресурс существует, пока существует турнир, а браузер красит
 * 404 красным всегда — самый обычный сценарий выглядел в консоли как сбой и создавал
 * фон, в котором теряется настоящая ошибка (KAN-1055).
 * `null`, а не пустой объект с нулями: «игрока нет в данных турнира» и «сыграл, но
 * ничего не делал» — разные факты, нули выглядели бы как второе.
 * 404 остаётся там, где ресурса действительно нет: несуществующий турнир.
 * {@link /tournaments/:tournamentId/replay-metrics/players/:userId}
 */
export function useGetTournamentsTournamentidReplayMetricsPlayersUserid<
  TData =
    ResponseConfig<GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse>,
  TQueryKey extends QueryKey =
    GetTournamentsTournamentidReplayMetricsPlayersUseridQueryKey,
>(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["tournamentId"]
    | undefined,
  userId:
    | GetTournamentsTournamentidReplayMetricsPlayersUseridPathParams["userId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsTournamentidReplayMetricsPlayersUseridQueryResponse>,
        ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsPlayersUserid404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTournamentsTournamentidReplayMetricsPlayersUseridQueryKey(
      tournamentId,
      userId,
    );

  const query = useQuery(
    {
      ...getTournamentsTournamentidReplayMetricsPlayersUseridQueryOptions(
        tournamentId,
        userId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetricsPlayersUserid404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
